import { Row, Col, SubHeading } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { CopyButton } from './CopyButton';

interface AIAnswerHeaderProps {
  answer?: string;
}

export const AIAnswerHeader = ({ answer }: AIAnswerHeaderProps) => {
  const AI_ANSWER_TITLE = I18n.t('js.learner.ai_search.answer_title');

  return (
    <Row justify="space-between" align="center">
      <Col xs="auto">
        <SubHeading level="xl">{AI_ANSWER_TITLE}</SubHeading>
      </Col>
      <Col xs="auto">
        <CopyButton answer={answer} />
      </Col>
    </Row>
  );
};
